import { useMemo } from 'react'

import { TeamRole } from '@/consts/team'
import { TeamFSContext } from '@/pages/data-mgr/core/context'
import { type RenameDialogProps, useRenameCore } from '@/pages/data-mgr/core/hooks/useRename'

export type { RenameDialogProps }

export function useTeamRename(domain: number, userRole: TeamRole, teamId: number) {
  const context = useMemo(() => new TeamFSContext(userRole, teamId), [userRole, teamId])
  return useRenameCore(context, domain)
}
